<template>
  <div class="online-consulting">
    <el-row :gutter="24">
      <!-- 左侧咨询列表 -->
      <el-col :span="10">
        <div class="list-card" v-loading="loading">
          <div class="card-header">
            <div class="filter-buttons">
              <el-radio-group v-model="listType" size="small" @change="handleTypeChange">
                <el-radio-button label="public" class="filter-btn">大厅</el-radio-button>
                <el-radio-button label="mine" class="filter-btn">我的</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="list-content">
            <div v-for="item in consultingList" 
                 :key="item.id"
                 class="list-item"
                 :class="{ active: activeItem === item.id }"
                 @click="handleItemClick(item)">
              <div class="item-header">
                <div class="item-title">{{ item.cate }}</div>
                <el-tag size="small" type="info" v-if="item.status == '2'">
                   处理中
                </el-tag>
                <el-tag size="small" type="success" v-else-if="item.status == '3'">
                    已完成
                </el-tag>
                <!-- <el-tag size="small" :type="item.status === 'pending' ? 'warning' : 'success'">
                  {{ item.status === 'pending' ? '待回复' : '已回复' }}
                </el-tag> -->
              </div>
              <div class="item-preview">{{ item.content }}</div>
              <div class="item-info">
                <span>{{ item.time }}</span>
                <span>{{ item.creator }}</span>
              </div>
            </div>
            
            <!-- 分页器 -->
            <div class="pagination-container">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageParams.page"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageParams.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-col>

      <!-- 右侧咨询详情 -->
      <el-col :span="14">
        <div class="detail-card" v-loading="detailLoading">
          <div class="card-header">
            咨询详情
            <el-button v-if="currentDetail && qaList.length > 0 && currentDetail.status == '2'"
                      @click="handleComplete" 
                      type="success" 
                      size="small"
                      :loading="completing">
              完成咨询
            </el-button>
          </div>
          <div class="detail-content" v-if="currentDetail">
            <div class="detail-header">
              <h2 class="detail-title">{{ currentDetail.cate }}</h2>
              <!-- <el-tag size="medium" :type="currentDetail.status === 'pending' ? 'warning' : 'success'">
                {{ currentDetail.status === 'pending' ? '待回复' : '已回复' }}
              </el-tag> -->
            </div>
            <div class="detail-info">
              <span>提交时间：{{ currentDetail.time }}</span>
              <span>咨询人：UID{{ currentDetail.uid }}</span>
              <span v-if="currentDetail.lawyer">接待律师：{{ currentDetail.lawyer }} 
                <i class="el-icon-edit" @click="handleEditLawyer" v-if="currentDetail.isadmin"></i>
              </span>
            </div>
            <div class="detail-main">
              <h3>咨询内容：</h3>
              <div class="detail-description">
                {{ currentDetail.content }}
              </div>
              
              <!-- 接单按钮 -->
              <div v-if="currentDetail.status == '1'" class="action-area">
                <el-button type="primary" @click="handleTakeOrder">接单</el-button>
              </div>

              <!-- 问答记录和回复区域 -->
              <div v-else class="qa-section">
                <!-- 问答记录列表 -->
                <div class="qa-list">
                  <h3>问答记录</h3>
                  <div class="qa-item" v-for="(item, index) in qaList" :key="index">
                    <div class="qa-user" :class="{ 'lawyer-reply': item.utype == 'lawyer' }">
                      <el-avatar :size="40" :src="item.avatar">
                        {{ item.utype == 'lawyer' ? '律师' : '用户' }}
                      </el-avatar>
                      <div class="qa-content">
                        <div class="qa-info">
                          <span class="name" v-if="item.utype == 'lawyer'">
                            {{ '工号' + item.uid }}
                           
                          </span>
                          <span class="name" v-else>{{ 'UID' + item.uid }}</span>
                          <span class="time">{{ item.time }}</span>
                        </div>
                        <div class="message">{{ item.content }}</div>
                        <span class="name" v-if="item.utype == 'lawyer'">
                           
                            <i class="el-icon-delete" 
                               @click.stop="handleDeleteChat(item)"
                               v-if="item.utype == 'lawyer'"
                               title="删除此回复">
                            </i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 回复输入框和完成咨询按钮 -->
                <div class="reply-box">
                  <el-input
                    v-model="replyContent"
                    type="textarea"
                    :rows="4"
                    placeholder="请输入回复内容"
                  />
                  <div class="reply-actions">
                    <el-button type="primary" 
                              @click="handleReply" 
                              :loading="replying">
                      发送回复
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="empty-detail" v-else>
            请选择左侧咨询内容查看详情
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 添加编辑律师对话框 -->
    <el-dialog
      title="更换接待律师"
      :visible.sync="lawyerDialogVisible"
      width="400px"
      :close-on-click-modal="false">
      <el-form :model="lawyerForm" ref="lawyerForm" label-width="80px">
        <el-form-item label="选择律师" prop="lawyer">
          <el-select 
            v-model="lawyerForm.lawyer" 
            placeholder="请选择律师"
            style="width: 100%">
            <el-option
              v-for="item in handlers"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lawyerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEditLawyer" :loading="submittingLawyer">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import consultingApi from '@/api/consulting' // 需要创建此API文件
import caseApi from '@/api/case' // 添加这行引入

export default {
  name: 'OnlineConsulting',
  data() {
    return {
      qaList:[],
      activeItem: null,
      consultingList: [],
      currentDetail: null,
      listType: 'public', // 默认显示大厅
      loading: false,
      detailLoading: false,
      pageParams: {
        page: 1,
        pageSize: 10
      },
      total: 0,
      replyContent: '', // 回复内容
      replying: false, // 回复发送状态
      completing: false, // 添加完成咨询的loading状态
      handlers: [], // 律师列表
      lawyerDialogVisible: false, // 编辑律师对话框显示状态
      lawyerForm: {
        lawyer: '' // 选中的律师
      },
      submittingLawyer: false // 提交状态
    }
  },
  created() {
    this.fetchConsultingList()
  },
  methods: {
    // 获取咨询列表
    async fetchConsultingList() {
      try {
        this.loading = true
        const params = {
          ...this.pageParams,
          type: this.listType
        }
        const res = await consultingApi.getConsultingList(params)
        if (res.status === 200) {
          this.consultingList = res.data.list
          this.total = res.data.total
        }
      } catch (error) {
        console.error('获取咨询列表失败:', error)
        this.$message.error('获取列表失败，请重试')
      } finally {
        this.loading = false
      }
    },

    // 获取律师列表
    async fetchHandlers() {
      try {
        const response = await caseApi.getLawyerList();
        console.log(response);
        this.handlers = response.data.map(item => ({
          value: item.uid,
          label: item.real_name
        }));
        console.log(this.handlers);
      } catch (error) {
        this.$message.error('获取律师列表失败')
        console.error('获取律师列表失败:', error)
      }
    },

    // 编辑接待律师
    async handleEditLawyer() {
      // 获取律师列表
      await this.fetchHandlers()
      
      // 设置当前律师
      if (this.currentDetail.lawyerid) {
        this.lawyerForm.lawyer = this.currentDetail.lawyerid
      } else {
        this.lawyerForm.lawyer = ''
      }
      
      // 显示对话框
      this.lawyerDialogVisible = true
    },

    // 提交编辑律师
    async submitEditLawyer() {
      if (!this.lawyerForm.lawyer) {
        this.$message.warning('请选择律师')
        return
      }


      try {
        this.submittingLawyer = true
        const res = await consultingApi.updateLawyer({
          id: this.currentDetail.id,
          lawyer: this.lawyerForm.lawyer
        })
        
        if (res.status === 200) {
          this.$message.success('更新成功')
          this.lawyerDialogVisible = false
          // 重新获取详情
          await this.handleItemClick(this.currentDetail)
        }
      } catch (error) {
        this.$message.error('更新失败，请重试')
        console.error('更新律师失败:', error)
      } finally {
        this.submittingLawyer = false
      }
    },

    // 换大厅/我的
    handleTypeChange(value) {
        console.log(value);
      this.pageParams.page = 1 // 切换类型时重置页码
      this.activeItem = null // 清空选中状态
      this.currentDetail = null // 清空详情
      this.fetchConsultingList()
    },

    // 切换每页条数
    handleSizeChange(val) {
      this.pageParams.pageSize = val
      this.pageParams.page = 1
      this.fetchConsultingList()
    },

    // 切换页码
    handleCurrentChange(val) {
      this.pageParams.page = val
      this.fetchConsultingList()
    },

    // 点击列表项
    async handleItemClick(item) {
      console.log(item)
      this.activeItem = item.id
      try {
        this.detailLoading = true
        const res = await consultingApi.getConsultingDetail({id: item.id})
        if (res.status === 200) {
          this.currentDetail = res.data.info;
          this.qaList = res.data.chat;
        }
      } catch (error) {
        console.error('获取咨询详情失败:', error)
        this.$message.error('获取详情失败，请重试')
      } finally {
        this.detailLoading = false
      }
    },
    handleNewConsulting() {
      // TODO: 实现新建咨询功能
    },
    downloadFile(file) {
      // TODO: 实现文件下载功能
    },
    // 接单处理
    async handleTakeOrder() {
      try {
        this.detailLoading = true
        const res = await consultingApi.takeOrder({ id: this.currentDetail.id })
        if (res.status === 200) {

          if(res.data.st === 2){
            this.$message.error('该订单已有人接单')
            await this.fetchConsultingList()
            this.currentDetail = null
            return
          }


          this.$message.success('接单成功')
          // 重新获取详情和列表
          await this.handleItemClick(this.currentDetail)
          await this.fetchConsultingList()

        }
        // if(res.status === 400){
        //   this.$message.error(res.msg)
        //   await this.fetchConsultingList()
        //   this.currentDetail = null
        // }
      } catch (error) {
        this.$message.error('接单失败，请重试')
      } finally {
        this.detailLoading = false
      }

    },

    // 发送回复
    async handleReply() {
      if (!this.replyContent.trim()) {
        this.$message.warning('请输入回复内容')
        return
      }

      try {
        this.replying = true
        const res = await consultingApi.sendReply({
          id: this.currentDetail.id,
          content: this.replyContent
        })
        if (res.status === 200) {
          this.$message.success('回复成功')
          this.replyContent = '' // 清空输入框
          // 重新获取详情
          await this.handleItemClick(this.currentDetail)
        }
      } catch (error) {
        this.$message.error('回复失败，请重试')
      } finally {
        this.replying = false
      }
    },

    // 完成咨询
    async handleComplete() {
      try {
        this.completing = true
        const res = await consultingApi.completeConsulting({ id: this.currentDetail.id })
        if (res.status === 200) {
          this.$message.success('咨询已完成')
          // 重新获取详情和列表
          await this.handleItemClick(this.currentDetail)
          await this.fetchConsultingList()
        }
      } catch (error) {
        this.$message.error('操作失败，请重试')
      } finally {
        this.completing = false
      }
    },

    // 删除问答记录
    async handleDeleteChat(item) {
      try {
        await this.$confirm('确定要删除这条回复吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        this.detailLoading = true
        const res = await consultingApi.deleteChat({
          id: item.id
        })
        
        if (res.status === 200) {
          this.$message.success('删除成功')
          // 重新获取详情
          await this.handleItemClick(this.currentDetail)
        }
      } catch (error) {
        if (error !== 'cancel') { // 忽略取消操作的错误
          this.$message.error('删除失败，请重试')
          console.error('删除问答记录失败:', error)
        }
      } finally {
        this.detailLoading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.online-consulting {
  .list-card,
  .detail-card {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    height: calc(100vh - 230px);
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .card-header {
      padding: 16px;
      font-weight: 500;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .list-content {
    flex: 1;
    overflow-y: auto;
    padding: 0 16px;

    .list-item {
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background: #f5f5f5;
      }

      &.active {
        background: #e6f7ff;
      }

      .item-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;

        .item-title {
          font-weight: 500;
          font-size: 14px;
        }
      }

      .item-preview {
        color: #666;
        font-size: 13px;
        margin-bottom: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .item-info {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #8c8c8c;
      }
    }
  }

  .detail-content {
    padding: 20px;
    overflow-y: auto;
    height: calc(100% - 56px);

    .detail-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;

      .detail-title {
        margin: 0;
        font-size: 18px;
        color: #262626;
      }
    }

    .detail-info {
      background: #fafafa;
      padding: 12px 16px;
      border-radius: 4px;
      margin-bottom: 24px;

      span {
        margin-right: 24px;
        color: #666;
        font-size: 13px;
      }
    }

    .detail-main {
      h3 {
        font-size: 14px;
        color: #262626;
        margin: 20px 0 12px;
      }

      .detail-description {
        line-height: 1.8;
        color: #262626;
        margin-bottom: 24px;
      }

      .attachment-list {
        .attachment-item {
          display: flex;
          align-items: center;
          padding: 8px 0;

          i {
            color: #8c8c8c;
            margin-right: 8px;
          }

          .file-name {
            flex: 1;
            margin-right: 16px;
          }
        }
      }

      .detail-reply {
        background: #f5f5f5;
        padding: 16px;
        border-radius: 4px;
        margin-top: 24px;

        .reply-content {
          line-height: 1.8;
          margin-bottom: 12px;
        }

        .reply-info {
          color: #8c8c8c;
          font-size: 12px;

          span {
            margin-right: 16px;
          }
        }
      }

      .action-area {
        text-align: center;
        margin: 24px 0;
      }

      .qa-section {
        margin-top: 24px;

        .qa-list {
          margin-bottom: 24px;
          max-height: 400px;
          overflow-y: auto;

          .qa-item {
            margin-bottom: 20px;

            .qa-user {
              display: flex;
              align-items: flex-start;

              &.lawyer-reply {
                flex-direction: row-reverse;
                
                .qa-content {
                  margin-right: 12px;
                  margin-left: 0;
                  align-items: flex-end;

                  .message {
                    background: #e6f7ff;
                  }
                }
              }

              .qa-content {
                margin-left: 12px;
                display: flex;
                flex-direction: column;
                flex: 1;

                .qa-info {
                  margin-bottom: 4px;
                  font-size: 12px;
                  color: #8c8c8c;

                  .name {
                    margin-right: 8px;
                    font-weight: 500;
                  }
                }

                .message {
                  padding: 12px 16px;
                  background: #f5f5f5;
                  border-radius: 4px;
                  line-height: 1.6;
                  display: inline-block;
                  max-width: 80%;
                }
              }
            }
          }
        }

        .reply-box {
          border-top: 1px solid #f0f0f0;
          padding-top: 20px;

          .reply-actions {
            margin-top: 12px;
            text-align: right;
            display: flex;
            justify-content: flex-end;
            gap: 12px;
          }
        }
      }
    }
  }

  .empty-detail {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #8c8c8c;
  }

  .filter-buttons {
    .el-radio-group {
      display: flex;
      :deep(.el-radio-button__inner) {
        border-radius: 0;
      }
      :deep(.el-radio-button:first-child .el-radio-button__inner) {
        border-radius: 4px 0 0 4px;
      }
      :deep(.el-radio-button:last-child .el-radio-button__inner) {
        border-radius: 0 4px 4px 0;
      }
    }
  }

  .pagination-container {
    padding: 16px;
    text-align: center;
    background: #fff;
    border-top: 1px solid #f0f0f0;
  }

  // 添加编辑图标样式
  .el-icon-edit {
    cursor: pointer;
    margin-left: 4px;
    color: #409EFF;
    
    &:hover {
      color: #66b1ff;
    }
  }
  .el-icon-delete {
    cursor: pointer;
    margin-left: 4px;
    color: #F56C6C;
    font-size: 12px;
    &:hover {
      color: #ff7875;
    }
  }

  .qa-section {
    .qa-list {
      .qa-item {
        .qa-user {
          .qa-content {
            .qa-info {
              .name {
                position: relative;
                
                .el-icon-delete {
                  cursor: pointer;
                  margin-left: 4px;
                  color: #F56C6C;
                  font-size: 14px;
                  opacity: 0;
                  transition: opacity 0.3s;
                  
                  &:hover {
                    color: #ff7875;
                  }
                }
              }
            }
          }

          &:hover {
            .el-icon-delete {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}
</style> 